// @flow

/**
 * Module dependencies.
 */

import { css } from 'styled-components';

/**
 * Export states.
 */

export const states = {
  action: (...args: any): any => css`
    &,
    &:active,
    &:focus,
    &:hover,
    &:visited {
      ${css(...args)}
    }
  `,
  interaction: (...args: any): any => css`
    &.active,
    &:active,
    &:focus,
    &:hover {
      ${css(...args)}
    }
  `
};



// WEBPACK FOOTER //
// ../src/client/styles/states.js